export const enum ResponsivePictureLayout {
    None,
    /**
     * Covers the container, clipping to fit the aspect ratio
     */
    ObjectFitCover,
    /** Emulates object-fit: contain using the image dimensions */
    ObjectFitContain,
}
